module.exports = __webpack_public_path__ + "img/tuscaloosa-public-services-logo.9cff58d6.jpg";